import { sumBy } from 'lodash';
import React, { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import './CollegeDistributeContainer.scss';
import { moduleActions } from '../../redux/modules';
import { getEligibleBanks } from '../../redux/modules/existingBanks/existingBanks.selectors';
import {
  getIsValidRedemption,
  getRedemptionPayload,
} from '../../redux/modules/executeRedemption/executeRedemption.selectors';
import {
  getSellTransactionIsValid,
  getIsUserWithAtleastOneRMDEligibleFund,
} from '../../redux/modules/sellTransaction/sellTransaction.selectors';
import { getUpdatedPaperless } from '../../redux/modules/user/Paperless/paperless.selectors';
import {
  analyticsDataLayer,
  dispatchPageLoad,
} from '../../redux/utils/analytics-helper';
import { scrollElementIntoFullView } from '../../utils/dom-utils';
import { appendBasePath } from '../../utils/nav.utils';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../redux/modules/authentication/authentication.module.selectors';
import {
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
  IAS_DELIVERY_MAIL_CHECK,
} from 'src/settings/settings';
import { getStudentDetails } from 'src/redux/modules/studentDetail';
import { getSelectedSchool } from 'src/redux/modules/schoolSelection';
import { generateDTSCommunicationTransactions } from '../../components/CollegeDistribute/DistributeToSchoolUtils';

export class CollegeDistributeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.checkAppFailed = this.checkAppFailed.bind(this);
    this.submitRedemption = this.submitRedemption.bind(this);
    this.handleCommunications = this.handleCommunications.bind(this);
    this.handleStep2Transition = this.handleStep2Transition.bind(this);
  }

  componentDidMount() {
    const {
      actions,
      actions: {
        getEstimationDates,
        getTRPFunds,
        loadApplication,
        setAppLoading,
        setProgress,
      },
    } = this.props;

    getEstimationDates();
    getTRPFunds();
    loadApplication(actions);
    setAppLoading();
    setProgress(0);
  }

  componentDidUpdate(prevProps) {
    const {
      executeRedemption: {
        redemption: { redemptionResultLoading: wasLoading },
        validation: { validationResultLoading: validationLoading },
      },
    } = prevProps;
    const {
      executeRedemption: {
        redemption: { redemptionResultFailed, redemptionResultSuccess },
        validation: { validationResultLoaded },
      },
      history,
    } = this.props;

    if (wasLoading && redemptionResultSuccess) {
      history.push(appendBasePath('/college/distribute/confirm'));
    }

    if (wasLoading && redemptionResultFailed) {
      dispatchPageLoad('Submission Error Page');
    }

    if (validationLoading && validationResultLoaded) {
      this.handleStep2Transition();
    }
    this.checkAppFailed(prevProps);
  }

  checkAppFailed(prevProps) {
    const {
      applicationData: { hasFailed: appFailed },
    } = this.props;
    const {
      applicationData: { isLoading: appWasLoading },
    } = prevProps;

    if (appWasLoading && appFailed) {
      dispatchPageLoad('App Error Page');
    }
  }

  handleStep2Transition() {
    const {
      actions: { setProgress, setValidationFailed },
      isValidRedemption,
    } = this.props;

    if (isValidRedemption) {
      setProgress(3);
      scrollElementIntoFullView('review-step');
    } else {
      setValidationFailed();
    }
  }

  handleCommunications(isDTSTransaction = false) {
    const {
      actions: {
        clearAARCache,
        sendConfirmationEmail,
        updateUserPaperlessSettings,
      },
      executeRedemption: {
        redemption: { successfulTransactions },
      },
      updatedPaperless,
    } = this.props;
    if (successfulTransactions.length) {
      let transactions;
      if (isDTSTransaction) {
        transactions = generateDTSCommunicationTransactions(
          successfulTransactions
        );
      } else {
        transactions = successfulTransactions.map((transaction) => {
          return { ...transaction, '@Type': 'Transaction' };
        });
      }

      sendConfirmationEmail(transactions);
      if (updatedPaperless) {
        updateUserPaperlessSettings();
      }
      // must call this in order for the transaction to immediately show up in pending transaction display in AAW
      clearAARCache();
    }
  }

  submitRedemption() {
    const {
      actions: {
        sendRedemption,
        setRedemptionResultStart,
        setRedemptionResultFailed,
        setRedemptionResultSuccessful,
        resetTransaction,
        sendDtsRedemption,
      },
      dispatch,
      executeRedemption: {
        validation: { isValidRedemption },
      },
      redemptionPayload,
      sellDeliveryMethod: { deliveryMethod },
      studentDetail,
      selectedSchool,
    } = this.props;
    try {
      analyticsDataLayer({
        amount: sumBy(redemptionPayload, (trx) =>
          trx.amount ? trx.amount : 0
        ),
        quantity: redemptionPayload.length,
      });
    } catch (e) {
      // don't let analytics errors cause other things to fail
    }

    setRedemptionResultStart();
    scrollElementIntoFullView('TopNav');
    if (isValidRedemption) {
      let transactionsSubmissionArray;

      if (deliveryMethod !== DELIVERY_MAIL_CHECK_TO_SCHOOL) {
        transactionsSubmissionArray = redemptionPayload.map((transaction) =>
          dispatch(sendRedemption(JSON.stringify(transaction)))
        );

        const manageExecution = (promise) =>
          promise.then(
            (result) => ({
              result,
              status: 'RESOLVED',
            }),
            (error) => ({
              error,
              status: 'REJECTED',
            })
          );

        Promise.all(transactionsSubmissionArray.map(manageExecution)).then(
          (results) => {
            if (
              results.every(
                (transactionResult) => transactionResult.status === 'RESOLVED'
              )
            ) {
              setRedemptionResultSuccessful();
              this.handleCommunications();
            } else {
              setRedemptionResultFailed();
              this.handleCommunications();
            }
          }
        );
      } else {
        const transactionRedeemRequestArray = redemptionPayload.map(
          (transaction) => {
            return {
              ...transaction,
              delivery: {
                enumerationID: 7,
                enumerationName: IAS_DELIVERY_MAIL_CHECK,
              },
            };
          }
        );
        const transactionsSubmissionData = dispatch(
          sendDtsRedemption(
            JSON.stringify({
              transactionRedeemRequest: transactionRedeemRequestArray,
              payeeDetail: {
                studentDetail: {
                  studentID: studentDetail.student.id,
                  studentName: {
                    firstName: studentDetail.student.firstName,
                    lastName: studentDetail.student.lastName,
                  },
                },
                college: {
                  name: selectedSchool.schoolName,
                  ID: '',
                },
                payeeAddress: {
                  '@Type': 'Address',
                  addressLines: [
                    selectedSchool.addressLineOne,
                    selectedSchool.addressLineTwo,
                  ],
                  city: selectedSchool.city,
                  state: selectedSchool.state,
                  zipCode: selectedSchool.zip,
                  zipCodeExt: selectedSchool.zipExt,
                  country: 'US',
                },
              },
            })
          )
        );

        const manageExecution = (promise) =>
          promise.then(
            (result) => ({
              result,
              status: 'RESOLVED',
            }),
            (error) => ({
              error,
              status: 'REJECTED',
            })
          );

        Promise.all([transactionsSubmissionData].map(manageExecution)).then(
          (results) => {
            if (
              results.every(
                (transactionResult) => transactionResult.status === 'RESOLVED'
              )
            ) {
              setRedemptionResultSuccessful();
              this.handleCommunications(true);
            } else {
              setRedemptionResultFailed();
              this.handleCommunications(true);
            }
          }
        );
      }
      resetTransaction();
    }
  }

  render() {
    const { children, ...otherProps } = this.props;
    return (
      <div className="college-distribute-container">
        {React.Children.map(children, (child) =>
          cloneElement(child, {
            ...otherProps,
            analyticsDataLayer,
            dispatchPageLoad,
            submitRedemption: this.submitRedemption,
          })
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    applicationData,
    executeRedemption,
    paperlessSetting,
    personalInformation,
    progress,
    sellDeliveryMethod,
  } = state;
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    applicationData,
    eligibleBanks: getEligibleBanks(state),
    executeRedemption,
    isUserWithAtleastOneRMDEligibleFund:
      getIsUserWithAtleastOneRMDEligibleFund(state),
    isValidRedemption: getIsValidRedemption(state),
    paperlessSetting,
    personalInformation,
    progress,
    redemptionPayload: getRedemptionPayload(state), // [0] will be removed when the services allows for multiple trnx
    updatedPaperless: getUpdatedPaperless(state),
    validRedemption: getSellTransactionIsValid(state),
    studentDetail: getStudentDetails(state),
    selectedSchool: getSelectedSchool(state),
    sellDeliveryMethod,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...moduleActions }, dispatch),
  dispatch,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CollegeDistributeContainer);
